
import GlobalCom from './GlobalCom'
export default {
  // 通过install来拿到全局的Vue对象
  install (app) {
    //  注册全局的通用栏组件对象
    app.component('GlobalCom', GlobalCom)
  }
}
